<template>
  <el-main>
  
  
        <vxe-table
          border
          max-height="600"
          ref="xTable1"
          :row-config="{isHover: true}"
          :cell-style="cellStyle"
          :data="xmList"
          @filter-visible="filterVisibleEvent"
          @filter-change="filterChangeEvent">
 
          <vxe-column field="xmname" title="项目名" sortable 
          :filters="[{ data: '' }]"
          :filter-method="filterTizuMethod">
          
          <template #filter="{ $panel, column }">
              <select class="my-select" v-model="option.data" v-for="(option, index) in column.filters" :key="index" @change="$panel.changeOption($event, !!option.data, option)">
                <option v-for="(label, cIndex) in tizuList" :key="cIndex" :value="label">{{ label }}</option>
              </select>
            </template>

          </vxe-column>
          <vxe-column 
          field="xm_grade" title="年级" sortable >
        </vxe-column>

        <vxe-column 
          field="xm_grade" title="查看详情" sortable >

            <template #default="{ row }">
              <vxe-button type="text" status="success" content="查看详情" @click="editEvent(row)"></vxe-button>
             
            </template>

        </vxe-column>

  
        </vxe-table>

   

  <el-dialog :title="title" :visible.sync="dialogTableVisible" :close-on-press-escape="false" :close-on-click-modal="false">
    <el-table 
       stripe
       border
       :default-sort = "{prop: 'yjschool', order: 'ascending'}"

      :row-style="{height:'20px'}"
      :cell-style="{padding:'0px'}"
      :data="singleTizuData">
        <el-table-column sortable property="yjschool" label="学校" width="150"></el-table-column>
        <el-table-column property="yjer" label="账号" width="150"></el-table-column>
        <el-table-column property="xm" label="姓名" width="100"></el-table-column>
        <el-table-column property="yjcount" label="阅卷数量" width="100"></el-table-column>
        <el-table-column property="junfen" label="平均分" width="100"></el-table-column>      
    </el-table>
  </el-dialog>

<div id="people">
  <v-client-table :data="tableData" :columns="columns" :options="options"/>
</div>

  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          singleTizuData:[],
          currentRow: null,
          status:false,
          title:'hello world',
          schoolList:[],
          tizuList:[],
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
            sel_xm:'',
            sel_sb:'',
            dialogTableVisible: false,
                      
         };
  },
   activated() {
			console.log('单科进度查询页面');
			//阅卷题组信息
			//this.sel_xm=this.$route.query.xm;
      //this.sel_sb=this.$route.query.subject;
     // this.xmList=[];
      this.handleDankeJinDu();

	},
  methods: {
    // 星号处理手机号
    noPassByMobile(str){
        if(null != str && str != undefined){
            var pat=/(\d{3})\d*(\d{4})/;
            return str.replace(pat,'$1****$2');
        } else {
            return "";
        }
    },

     // 星号处理名称
    noPassByName(str){
        if(null != str && str != undefined){
            if(str.length <= 3){
                return "*" + str.substring(1,str.length);
            } else if(str.length > 3 && str.length <= 6){
                return "**" + str.substring(2,str.length);
            } else if(str.length > 6){
                return str.substring(0,2) + "****" + str.substring(6,str.length)
            }
        } else {
            return "";
        }
      },

    handleDankeJinDu()
    {	
        // axios.post('/sn?op=jp',qs.stringify({"xm":this.sel_xm,"kemu":this.sel_sb})).then((res)=>{
        axios.post('/sn?op=exameList').then((res)=>{
              console.log(res)
              console.log(res.data)
              this.xmList=res.data;           

              
          }).catch((res)=>{
              console.log(response)
          })      

    },

    filterRoleMethod ({ option, row }) {
              return row.sc === option.data
    },

    filterTizuMethod ({ option, row }) {
              return row.tz === option.data
    },

    editEvent (row) {
          
               this.$router.push({ path: '/jinduxqxm', query: { xm: row.xmname }});            

     },
          

    cellStyle ({ row, rowIndex, column }) {
              if (column.property === 'wc-fc') {
                if (row.wc >=row.fc) {
                  return {
                    backgroundColor: '#187',
                    color: '#ffffff'
                  }
                } else {
                  return {
                    backgroundColor: '#2db7f5',
                    color: '#000'
                  }
                }
              }
               
     },
     
    

   

  },
}
</script>

<style scoped>
.el-dialog {
     display: flex;
     flex-direction: column;
     margin:0 !important;
     position:absolute;
     top:50%;
     left:50%;
     transform:translate(-50%,-50%);
     /*height:600px;*/
     max-height:calc(100% - 200px);
     max-width:calc(100% - 30px);
}
.el-dialog .el-dialog__body {
     flex:1;
     overflow: auto;
}

</style>